import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';

import { typeToPluralUserVisibleString } from '../../../../library/selection/types';
import { PartialMovementTransformation, TransformableType } from '../../../../library/transformations/types';
import { isTransformationFullyDefined } from '../../../../library/transformations/validation';
import { applyPendingTransformationIfFullyDefined } from '../../../../store/actions/layout/transformationActions';
import { useAppDispatch } from '../../../hooks';
import { LayoutPointPickerField } from '../../subpanels/insertions/truss-envelope/LayoutPointPickerField';
import { ManualMovementControls } from './ManualMovementControls';

export function MovementControls(props: {
  targetType: TransformableType;
  transformation: PartialMovementTransformation;
}) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Typography sx={{ padding: 1 }}>
        {props.transformation.duplicate ? 'Duplicate and move' : 'Move'} the selected{' '}
        {typeToPluralUserVisibleString(props.targetType)} by the distance and direction between two points.
      </Typography>

      <Box sx={{ margin: 1, padding: 1 }}>
        <LayoutPointPickerField
          label="Origin"
          value={props.transformation.type === 'movement' ? props.transformation.origin : undefined}
          target="transformation-origin"
        />
      </Box>

      <Box sx={{ margin: 1, padding: 1 }}>
        <LayoutPointPickerField
          label="Destination"
          value={props.transformation.type === 'movement' ? props.transformation.destination : undefined}
          target="transformation-destination"
        />
      </Box>

      <Box sx={{ padding: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={() => void dispatch(applyPendingTransformationIfFullyDefined())}
          disabled={!isTransformationFullyDefined(props.transformation)}
        >
          Apply
        </Button>
      </Box>

      <Divider sx={{ marginX: 6, marginY: 2 }} />

      <ManualMovementControls targetType={props.targetType} sx={{ paddingX: 1 }} />
    </>
  );
}
